import cn from 'classnames';
import { forwardRef, HTMLAttributes } from 'react';

type PriceDeviationPercentProps = {
  isNeutral: boolean;
  isPositive: boolean;
  isNegative: boolean;
  theme?: 'light' | 'dark';
} & HTMLAttributes<HTMLSpanElement>;

export const PriceDeviationPercent = forwardRef<HTMLSpanElement, PriceDeviationPercentProps>(
  (props, ref) => {
    const {
      isNeutral,
      isPositive,
      isNegative,
      theme = 'dark',
      children,
      ...elementAttributes
    } = props;

    return (
      <span
        className={cn({
          'text-gray-400': isNeutral,
          [theme === 'dark' ? 'text-green-400' : 'text-green-700']: isPositive,
          [theme === 'dark' ? 'text-orange-400' : 'text-orange-700']: isNegative,
        })}
        ref={ref}
        {...elementAttributes}
      >
        {children}
      </span>
    );
  },
);
